import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { frFR } from "@clerk/localizations";
import { Splash } from "@/components/Splash";

const appearance = {
  theme: dark,
  variables: {
    colorPrimary: "#25E46B",
    colorPrimaryForeground: "#0B132B",
    colorBackground: "#111C38",
    colorForeground: "#F8FAFC",
    colorInput: "#162244",
    colorInputForeground: "#F8FAFC",
    colorBorder: "rgba(255,255,255,0.12)",
    fontFamily: "Manrope, system-ui, sans-serif",
    borderRadius: "0.8rem",
  },
  captcha: { theme: "dark" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fz_clerk_cfg")) || null; } catch { return null; }
  });
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) {
          localStorage.setItem("fz_clerk_cfg", JSON.stringify(cfg));
          return cancelled || setConfig((old) => (old && old.publishable_key === cfg.publishable_key && old.proxy_url === cfg.proxy_url ? old : cfg));
        }
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Connexion indisponible pour le moment. Rafraîchis la page pour réessayer.</p>;
  if (!config) return <Splash />;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={frFR}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
